import React from 'react';

const PhoneComplete = (props) => (
  <svg width='240' height='243' viewBox='0 0 240 243' fill='none' {...props}>
    <g>
      <path
        d='M120 242.005c66.274 0 120-3.156 120-7.049 0-3.892-53.726-7.048-120-7.048S0 231.064 0 234.956c0 3.893 53.726 7.049 120 7.049Z'
        fill='#E6E6E6'
      />
      <path
        d='M136.035 55.835h-1.291V20.469A20.467 20.467 0 0 0 114.276 0H39.348A20.469 20.469 0 0 0 18.88 20.469v194.019a20.47 20.47 0 0 0 20.468 20.469h74.928a20.47 20.47 0 0 0 20.468-20.469V81.008h1.291V55.836Z'
        fill='#3F3D56'
      />
      <path
        d='M130.388 20.612v193.733a15.287 15.287 0 0 1-15.287 15.287H39.815a15.285 15.285 0 0 1-15.286-15.286V20.612A15.287 15.287 0 0 1 39.815 5.325h9.133a7.266 7.266 0 0 0 6.725 10.005h42.925a7.268 7.268 0 0 0 7.223-6.521 7.264 7.264 0 0 0-.498-3.484h9.778a15.287 15.287 0 0 1 15.287 15.287Z'
        fill='#fff'
      />
      <path d='M59.308 167.293h-1.584l.529-30.928h.529l.526 30.928Z' fill='#E6E6E6' />
      <path
        d='m60.627 116.894 2.556-3.95a59.254 59.254 0 0 0-2.622-6.137l-1.653 1.335 1.309-2.023c-1.248-2.454-2.229-4.001-2.229-4.001s-5.125 8.077-6.838 16.629l3.28 5.069-3.63-2.933c-.13.996-.196 2-.2 3.004 0 10.128 3.309 18.339 7.389 18.339s7.388-8.212 7.388-18.339c0-3.14-.71-6.424-1.691-9.463l-3.06 2.47Z'
        fill='#CCC'
      />
      <path d='M100.527 167.293h-1.584l.529-30.928h.529l.526 30.928Z' fill='#E6E6E6' />
      <path
        d='m101.846 116.894 2.556-3.95a59.211 59.211 0 0 0-2.622-6.137l-1.653 1.335 1.309-2.023c-1.247-2.454-2.229-4.001-2.229-4.001s-5.125 8.077-6.836 16.629l3.277 5.068-3.63-2.933c-.13.997-.196 2-.2 3.005 0 10.128 3.308 18.338 7.389 18.338 4.08 0 7.388-8.211 7.388-18.338 0-3.14-.71-6.425-1.692-9.464l-3.057 2.471Z'
        fill='#CCC'
      />
      <path
        d='M58.103 64.775c8.035 0 14.548-6.514 14.548-14.548 0-8.035-6.513-14.548-14.548-14.548s-14.548 6.513-14.548 14.548c0 8.034 6.513 14.548 14.548 14.548Zm20.15 98.015h-3.264l1.088-63.77h1.088l1.088 63.77Z'
        fill='#E6E6E6'
      />
      <path
        d='m80.973 58.873 5.27-8.143a122.103 122.103 0 0 0-5.406-12.656l-3.408 2.752 2.698-4.17c-2.572-5.062-4.594-8.25-4.594-8.25s-10.569 16.653-14.1 34.287l6.76 10.45-7.485-6.046a49.404 49.404 0 0 0-.41 6.194c0 20.884 6.82 37.813 15.233 37.813s15.234-16.93 15.234-37.813c0-6.474-1.465-13.247-3.485-19.513l-6.307 5.095Z'
        fill='#CCC'
      />
      <path
        d='M130.388 171.982v43.351c0 8.792-6.844 15.92-15.287 15.92H39.815c-8.443 0-15.287-7.127-15.287-15.92v-39.125c13.053-15.958 31.925-25.496 52.04-26.299 20.113-.803 39.632 7.202 53.82 22.073Z'
        fill='#E6E6E6'
      />
      <path
        opacity='.2'
        d='M77.54 214.745c12.303 0 22.276-9.974 22.276-22.276 0-12.303-9.973-22.276-22.276-22.276-12.303 0-22.276 9.973-22.276 22.276 0 12.302 9.973 22.276 22.276 22.276Z'
        fill='#6C63FF'
      />
      <path
        d='M77.54 210.405c9.906 0 17.937-8.03 17.937-17.936s-8.03-17.937-17.937-17.937c-9.906 0-17.937 8.031-17.937 17.937s8.031 17.936 17.937 17.936Z'
        fill='#6C63FF'
      />
      <path
        d='m75.448 200.137-6.321-8.127 3.676-2.859 2.993 3.848 10.11-10.673 3.381 3.203-13.839 14.608Z'
        fill='#fff'
      />
      <path
        d='M172.859 164.571c6.423 0 11.63-5.207 11.63-11.63 0-6.423-5.207-11.63-11.63-11.63-6.423 0-11.63 5.207-11.63 11.63 0 6.423 5.207 11.63 11.63 11.63Z'
        fill='#2F2E41'
      />
      <path d='m177.572 218.23.895 4.226 16.73-1.445-1.322-6.238-16.303 3.457Z' fill='#FFB8B8' />
      <path
        d='m176.269 231.439-2.815-13.285 5.132-1.087 1.728 8.151a5.243 5.243 0 0 1-.734 3.948 5.253 5.253 0 0 1-3.311 2.273Z'
        fill='#2F2E41'
      />
      <path d='m167.091 218.004-1.883 3.889-15.895-5.412 2.78-5.739 14.998 7.262Z' fill='#FFB8B8' />
      <path d='m162.754 224.136 3.631-7.5 4.722 2.286-5.918 12.222a5.245 5.245 0 0 1-2.435-7.008Z' fill='#2F2E41' />
      <path
        d='M135.774 210.324a3.783 3.783 0 0 0 3.102-.801 3.796 3.796 0 0 0 1.377-2.893l26.211-24.166-6.509-5.041-23.731 25.354a3.81 3.81 0 0 0-3.579 3.573 3.81 3.81 0 0 0 3.13 3.973l-.001.001Zm35.625-45.228a8.657 8.657 0 1 0-.001-17.313 8.657 8.657 0 0 0 .001 17.313Z'
        fill='#FFB8B8'
      />
      <path
        d='M179.167 207.321c-6.072 0-13.384-1.279-17.896-6.512l-.101-.118.106-.115c.035-.038 3.353-3.831.039-10.595l-4.557 1.402-4.536-5.987 2.513-7.538 10.283-8.282a9.417 9.417 0 0 1 5.148-2.041 28.294 28.294 0 0 0 9.792-2.789 9.837 9.837 0 0 1 4.511-.987l.202.006a3.504 3.504 0 0 1 3.398 3.773c-.697 9.033-1.928 30.853 1.689 38.365l.093.195-.208.053a48.001 48.001 0 0 1-10.475 1.169l-.001.001Z'
        fill='#6C63FF'
      />
      <path
        d='M162.462 200.694s-22.907-2.114-25.374 4.582c-2.467 6.696.352 9.867 4.581 11.277 4.229 1.41 14.449 3.172 14.449 3.172l4.582-5.639 11.982.705s13.352 7.744 17.043 16.026a10.837 10.837 0 0 0 9.085 6.427c2.96.206 5.59-.912 5.59-5.537 0-10.573-14.801-25.727-14.801-25.727l-27.137-5.286Z'
        fill='#2F2E41'
      />
      <path
        d='M145.017 211.09s5.991-1.762 15.507 2.82l-15.507-2.82Zm17.747-60.17a25.751 25.751 0 0 0 11.137 3.669l-1.174-1.407a8.612 8.612 0 0 0 2.664.529 2.927 2.927 0 0 0 2.379-1.113 2.713 2.713 0 0 0 .182-2.508 5.14 5.14 0 0 0-1.617-2.022 9.625 9.625 0 0 0-8.963-1.602 5.752 5.752 0 0 0-2.678 1.717 3.253 3.253 0 0 0-.657 3.017m8.759-7.199a26.614 26.614 0 0 1 6.744-9.348c1.865-1.656 4.044-3.081 6.501-3.511 2.458-.43 5.228.307 6.735 2.295 1.234 1.626 1.464 3.804 1.328 5.839-.136 2.036-.591 4.053-.547 6.091a12.498 12.498 0 0 0 17.807 11.049c-2.123 1.173-3.776 3.031-5.745 4.444-1.969 1.412-4.568 2.382-6.806 1.448-2.368-.987-3.454-3.672-4.302-6.093l-3.782-10.799c-.643-1.835-1.318-3.725-2.63-5.161-1.312-1.435-3.441-2.311-5.247-1.589-1.369.547-2.26 1.853-3.041 3.101-.782 1.249-1.606 2.58-2.925 3.235-1.319.656-3.278.252-3.709-1.157'
        fill='#2F2E41'
      />
      <path
        d='M175.766 207.351a3.878 3.878 0 0 1-2.673-6.698 3.878 3.878 0 0 1 2.667-1.056c.173.001.346.014.517.039l11.833-12.598-1.235-4.118 6.203-2.781 1.739 4.25a7.22 7.22 0 0 1-2.176 8.344l-13.025 10.361c.013.126.02.253.021.38a3.877 3.877 0 0 1-1.292 2.89 3.83 3.83 0 0 1-2.579.987Z'
        fill='#FFB8B8'
      />
      <path
        d='M185.017 165.452a3.32 3.32 0 0 1 2.613-.04 3.326 3.326 0 0 1 1.837 1.857l6.123 15.451-9.516 6.344-1.057-23.612Z'
        fill='#6C63FF'
      />
    </g>
  </svg>
);

export default PhoneComplete;
